// extracted by mini-css-extract-plugin
export default {"blankButton":"styles_blankButton__ohk7T","clicked":"styles_clicked__zxAvU"};